import * as React from "react";
import { useLocation, useNavigate } from "react-router";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";

type LocationState = Partial<{
    workoutShareSucceeded: boolean;
    journeyInstanceShareUlid: string;
}>;

const ShareSnackbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as LocationState | undefined;
    const [showSnackbar, setShowSnackbar] = React.useState(
        !!locationState?.workoutShareSucceeded ||
            !!locationState?.journeyInstanceShareUlid,
    );

    const onClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }

        setShowSnackbar(false);
    };

    const snackbarMessage = React.useMemo(() => {
        if (locationState?.workoutShareSucceeded) {
            return "New workouts added to your history!";
        }
        if (locationState?.journeyInstanceShareUlid) {
            return "VolleyIQ assessment added to your account!";
        }
        return null;
    }, [locationState]);

    const snackbarAction = React.useMemo(() => {
        if (locationState?.workoutShareSucceeded) {
            return (
                <Button
                    variant="contained"
                    color="info"
                    onClick={() => {
                        // clear the location state so hitting back from history
                        // page won't display this toast again
                        navigate("/", { replace: true, state: undefined });
                        navigate("/content/history-stats/mine");
                    }}
                >
                    View
                </Button>
            );
        }

        if (locationState?.journeyInstanceShareUlid) {
            return (
                <Button
                    variant="contained"
                    color="info"
                    onClick={() => {
                        navigate("/", { replace: true, state: undefined });
                        navigate(
                            `/journeys/assessments/${locationState.journeyInstanceShareUlid}/result`,
                        );
                    }}
                >
                    View
                </Button>
            );
        }

        return null;
    }, [locationState, navigate]);

    return (
        <Snackbar
            open={showSnackbar}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert severity="info" action={snackbarAction} onClose={onClose}>
                {snackbarMessage}
            </Alert>
        </Snackbar>
    );
};

export default ShareSnackbar;
